var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgConexaoCertificadaSebraeLogo = function SvgConexaoCertificadaSebraeLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.712,
    height: 23.771,
    viewBox: "0 0 33.712 23.771",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ccs2a{isolation:isolate;}.ccs2b{fill:#006ec7;}.ccs2c{fill:url(#abaa);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abaa",
    x1: 3.856,
    y1: -5.225,
    x2: 4.685,
    y2: -5.225,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006ec7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-633.571 -929.864)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ccs2a",
    transform: "translate(633.571 929.864)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ccs2b",
    d: "M374.179,571.977a3.08,3.08,0,0,1-2.183-.9,13.395,13.395,0,0,1,18.943-18.943l5.08,5.081a3.087,3.087,0,0,1-4.366,4.366l-5.08-5.08a7.219,7.219,0,0,0-10.21,10.209,3.088,3.088,0,0,1-2.183,5.271Z",
    transform: "translate(-368.072 -548.207)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(643.483 932.897)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ccs2c",
    d: "M106.953,214.234a3.48,3.48,0,0,0,4.921,0l11.918-11.918a3.48,3.48,0,1,1,4.922,4.921L116.8,219.155a3.48,3.48,0,0,1-4.921,0Z",
    transform: "translate(-105.934 -201.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ccs2b",
    d: "M107.583,238.771a3.48,3.48,0,1,0,0,4.921l2.461-2.461Z",
    transform: "translate(-101.642 -230.754)"
  }))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConexaoCertificadaSebraeLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/conexao-certificada-sebrae-logo.58ad219b.svg";
export { ForwardRef as ReactComponent };